"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Throttle = void 0;
var Throttle = /** @class */ (function () {
    function Throttle(queueName, timeout) {
        this.queueName = queueName;
        this.timeout = timeout;
    }
    Throttle.prototype.exec = function (callback) {
        var timestamp = Date.now();
        if (!Throttle.queue[this.queueName] || timestamp - Throttle.queue[this.queueName] >= this.timeout) {
            Throttle.queue[this.queueName] = timestamp;
            callback();
        }
    };
    Throttle.queue = {};
    return Throttle;
}());
exports.Throttle = Throttle;
//# sourceMappingURL=throttle.js.map